import React from "react";
import { withTranslation } from "react-i18next";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import styles from "./Modals.module.scss";
import crossIcon from "assets/images/cross.svg";

function AboutModal({ t, showSwitchOwnerModal, setShowSwitchOwnerModal }) {
  return (
    <Modal
      isOpen={showSwitchOwnerModal}
      toggle={() => setShowSwitchOwnerModal(false)}
      className={
        "modal-dialog-centered modal-width-660 " +
        styles["change-schedule-modal-dialog"]
      }
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => setShowSwitchOwnerModal(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" weight="500" color="#111b45" marginBottom="12px">
          {t("patientAppointmentMembers.patientAppointmentModalHeading")}
        </Text>
        <Text
          size="16px"
          weight="300"
          color="#535B5F"
          marginBottom="20px"
          lineHeight="24px"
        >
          {t("patientAppointmentMembers.patientAppointmentModalDescription")}
        </Text>

        <ul className={styles.bulletSection}>
          <li className={styles.list_marker}>
            <Text size="16px" weight="600" color="#535B5F">
             {t("patientAppointmentMembers.patientAppointmentModalFirstBullet")}:
            </Text>
            <ul className={styles.subBullet}>
              <li>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalFirstBulletFirst")}
                </Text>
              </li>
              <li>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalFirstBulletSecond")}
                </Text>
              </li>
            </ul>
          </li>

          <li className={styles.list_marker}>
            <Text size="16px" weight="600" color="#535B5F">
             {t("patientAppointmentMembers.patientAppointmentModalSecondBullet")}:
            </Text>
            <ul className={styles.subBullet}>
              <li>
                <Text size="16px" weight="400" color="#535B5F">
                {t("patientAppointmentMembers.patientAppointmentModalSecondBulletFirst")}
                </Text>
              </li>
              <li>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalSecondBulletSecond")}
                </Text>
              </li>
            </ul>
          </li>
          <li className={styles.list_marker}>
            <Text size="16px" weight="600" color="#535B5F">
              {t("patientAppointmentMembers.patientAppointmentModalThirdBullet")}:
            </Text>

            <ul className={styles.subBullet}>
              <li>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalThirdBulletFirst")}
                </Text>
              </li>
            </ul>
          </li>
          <li className={styles.list_marker}>
            <Text size="16px" weight="600" color="#535B5F">
              {t("patientAppointmentMembers.patientAppointmentModalFourthBullet")}:
            </Text>

            <ul className={styles.subBullet}>
              <li>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalFourthBulletFirst")}
                </Text>
              </li>
            </ul>
          </li>
          <li className={styles.list_marker}>
            <Text size="16px" weight="600" color="#535B5F">
              {t("patientAppointmentMembers.patientAppointmentModalFifthBullet")}:
            </Text>

            <ul className={styles["subBullet-multicolored"]}>
              <li>
                <span className={styles["box1"]}></span>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalFifthBulletFirst")}
                </Text>
              </li>
              <li>
                <span className={styles["box2"]}></span>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalFifthBulletSecond")}
                </Text>
              </li>
              <li>
                <span className={styles["box3"]}></span>
                <Text size="16px" weight="400" color="#535B5F">
                  {t("patientAppointmentMembers.patientAppointmentModalFifthBulletThird")}
                </Text>
              </li>
            </ul>
          </li>
        </ul>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AboutModal);
